module.exports = "<div class=auth-page> <div class=row> <div class=\"col-sm-12 login-header\"> <div class=logo> <img src=" + require("../../../assets/img/logo-blue.png") + " /> </div> </div> </div> <ui-view></ui-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/onboarding/onboarding.html
// module id = 458
// module chunks = 0